import { Component, input, computed } from '@angular/core';
import { ChangeDetectionStrategy } from '@angular/core';
import { CardComponent } from '../card/card.component';

/**
 * Componente específico para tarjetas KPI del dashboard
 * Encapsula el patrón común de las tarjetas de indicadores
 */
@Component({
  selector: 'app-kpi-card',
  standalone: true,
  imports: [CardComponent],
  templateUrl: './kpi-card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class KPICardComponent {
  /**
   * Título del KPI
   */
  title = input.required<string>();

  /**
   * Valor principal del KPI (número grande)
   */
  value = input.required<string | number>();

  /**
   * Texto secundario (opcional, ej: "vs mes anterior")
   */
  secondaryText = input<string>('');

  /**
   * Indicador de cambio (opcional, ej: "+12.5%")
   */
  changeIndicator = input<string>('');

  /**
   * Color del indicador de cambio
   * - 'success': Verde (positivo)
   * - 'error': Rojo (negativo)
   * - 'warning': Amarillo (neutro)
   * - 'info': Azul (información)
   */
  changeColor = input<'success' | 'error' | 'warning' | 'info'>('success');

  /**
   * Si debe mostrar el icono (proyectado via ng-content)
   */
  showIcon = input<boolean>(false);

  /**
   * Color del icono
   */
  iconColor = input<'primary' | 'success' | 'warning' | 'error' | 'info'>('primary');

  /**
   * Color de fondo del icono
   */
  iconBgColor = input<'primary' | 'success' | 'warning' | 'error' | 'info'>('primary');

  protected changeIndicatorClasses = computed(() => {
    const base = 'text-xs font-semibold';
    const colorClasses: Record<string, string> = {
      'success': 'text-success',
      'error': 'text-error',
      'warning': 'text-warning',
      'info': 'text-info'
    };
    return `${base} ${colorClasses[this.changeColor()]}`;
  });

  protected iconBgClasses = computed(() => {
    const colorClasses: Record<string, string> = {
      'primary': 'bg-blue-100',
      'success': 'bg-green-100',
      'warning': 'bg-orange-100',
      'error': 'bg-red-100',
      'info': 'bg-purple-100'
    };
    return `w-12 h-12 rounded-full ${colorClasses[this.iconBgColor()]} flex items-center justify-center`;
  });
}
